import React from 'react';
import { Box } from '@material-ui/core';
import { LoaderSubmitButton } from '../../../components/LoaderSubmitButton';
import { SmsOutlined } from '@material-ui/icons';
import { usePermissions } from '../../../modules/Permissions';

export const SendSMSActions = ({
  loading,
  disabled,
  sendSMS,
  sendCodeExchangeSMS,
  hideInviteSms = false,
}) => {
  const { hasCodeExchangeAccess } = usePermissions();

  return (
    <Box display="flex" gridGap="1rem">
      {!hideInviteSms && (
        <LoaderSubmitButton
          color="primary"
          icon={<SmsOutlined />}
          loading={loading}
          disabled={disabled}
          onClick={sendSMS}
        >
          Send SMS
        </LoaderSubmitButton>
      )}
      {hasCodeExchangeAccess && (
        <LoaderSubmitButton
          color="primary"
          icon={<SmsOutlined />}
          loading={loading}
          disabled={disabled}
          onClick={sendCodeExchangeSMS}
        >
          Send Code Exchange SMS
        </LoaderSubmitButton>
      )}
    </Box>
  );
};
